export const baseURL = "/.netlify/functions/server/";
export const SEND_EMAIL_CUSTOMER = "/send_mail_customer";
export const SEND_EMAIL_ADMIN = "/send_mail_admin";

//remove local host before deploying to netlify
